import { render, staticRenderFns } from "./SecondButton.vue?vue&type=template&id=4ad12220&scoped=true"
import script from "./SecondButton.vue?vue&type=script&lang=js"
export * from "./SecondButton.vue?vue&type=script&lang=js"
import style0 from "./SecondButton.vue?vue&type=style&index=0&id=4ad12220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad12220",
  null
  
)

export default component.exports